export default "__VITE_ASSET__9fca1d3d__"